var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c(
    "div",
    {
      staticClass: "reference-uniform-list-subcategories-position",
      class: {
        "reference-uniform-list-subcategories-childs": _vm.inSubcategory,
        "reference-uniform-list-subcategories-position-archive":
          _vm.type.isArchive,
        "reference-uniform-list-subcategories-position-active-hover":
          !_vm.type.isArchive,
      },
    },
    [
      _c(
        "div",
        {
          staticClass: "reference-uniform-list-subcategories-position-content",
        },
        [
          _c(
            "div",
            {
              staticClass: "reference-uniform-list-subcategories-position-name",
            },
            [_vm._v(" " + _vm._s(_vm.type.name) + " ")]
          ),
          _vm.responsible
            ? _c(
                "div",
                {
                  staticClass:
                    "reference-uniform-list-subcategories-position-responsible",
                },
                [
                  _c(
                    "a",
                    {
                      attrs: {
                        href: `/index.php?r=redesign#/personal-employee/${_vm.responsible.id}/summary`,
                        target: "_blank",
                      },
                    },
                    [_vm._v(_vm._s(_vm.responsible.name))]
                  ),
                ]
              )
            : _vm._e(),
        ]
      ),
      _c(
        "div",
        {
          staticClass: "reference-uniform-list-subcategories-position-buttons",
        },
        [
          _vm.type.descriptionModel.hasDescription
            ? _c("c-button", {
                staticClass:
                  "reference-uniform-list-subcategories-position-buttons-comment",
                attrs: { size: "iconic", icon: "comment" },
                on: {
                  click: function ($event) {
                    return _vm.$emit("showDescription")
                  },
                },
              })
            : _vm._e(),
          _c("type-actions", {
            staticClass:
              "reference-uniform-list-subcategories-position-buttons-menu",
            attrs: { type: _vm.type },
            on: {
              edit: function ($event) {
                return _vm.$emit("edit")
              },
              remove: function ($event) {
                return _vm.$emit("remove")
              },
              archiveOperation: function ($event) {
                return _vm.$emit("archiveOperation")
              },
            },
          }),
        ],
        1
      ),
    ]
  )
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }